"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[878],{

/***/ 4878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var assets_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1089);
/* harmony import */ var context_AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9941);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9059);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #2564ce;\n  padding: 12px 24px;\n  border-radius: 9999px;\n  color: #fff;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  height: 72px;\n  width: 100%;\n  left: 0;\n  right: 0;\n  top: 100%;\n  background: #fff;\n  .close-btn {\n    position: absolute;\n    border: 1px solid #4b4b4b;\n    border-radius: 50%;\n    padding: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    right: 80px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n  .close-btn svg {\n    flex-shrink: 0;\n  }\n  .left-img-wrapper,\n  .right-img-wrapper {\n    position: absolute;\n    width: 150px;\n    top: 0;\n    bottom: 0;\n  }\n  .left-img-wrapper {\n    left: 0;\n  }\n  .right-img-wrapper {\n    right: 0;\n  }\n\n  & .right-img {\n    transform: rotate(180deg);\n  }\n\n  .banner-mob {\n    display: none;\n    white-space: nowrap;\n  }\n  .banner-desk {\n    white-space: nowrap;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n  }\n  .banner-text {\n    text-transform: uppercase;\n    margin: 0 72px;\n  }\n  .banner-text strong {\n    color: ",
        ";\n  }\n\n  @media screen and (max-width: 769px) {\n    height: 42px;\n    .close-btn {\n      right: 45px;\n    }\n    .left-img-wrapper,\n    .right-img-wrapper {\n      width: 50px;\n    }\n    .banner-mob {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 100%;\n      color: ",
        ";\n    }\n    .banner-desk {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var HeaderPopupArea = function() {
    var ref = (0,context_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .useAppContext */ .b)(), isHeaderPopupOpen = ref.state.isHeaderPopupOpen, dispatch = ref.dispatch;
    var handleClosePopup = function() {
        return dispatch({
            type: "headerPopupClose"
        });
    };
    if (!isHeaderPopupOpen) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PopupArea, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "left-img-wrapper",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                    className: "left-img",
                    src: "/asset/header/header-popup-img.png",
                    alt: "",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "right-img-wrapper",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                    className: "right-img",
                    src: "/asset/header/header-popup-img.png",
                    alt: "",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "banner-desk",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_2__/* .KokoonIcon */ .Ww, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(global_styles__WEBPACK_IMPORTED_MODULE_4__/* .ButtonText1 */ .Ls, {
                        className: "banner-text",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: "Try "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                children: "Bluedot AI video "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: "Enhancer & Upscaling"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LearnMoreLink, {
                        className: "lm-anch",
                        href: "https://www.kokoon.cloud",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_4__/* .ButtonText1 */ .Ls, {
                            children: "Try now"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "banner-mob",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(global_styles__WEBPACK_IMPORTED_MODULE_4__/* .ButtonText1 */ .Ls, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            style: {
                                marginRight: "0.8rem"
                            },
                            children: "→"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            style: {
                                textDecoration: "underline",
                                color: "#2564ce"
                            },
                            target: "_blank",
                            href: "https://www.kokoon.cloud",
                            rel: "noreferrer",
                            children: "TRY BLUEDOT AI VIDEO"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                className: "close-btn",
                onClick: handleClosePopup,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_2__/* .HeaderPopupCloseIcon */ .ik, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HeaderPopupArea);
var LearnMoreLink = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "HeaderPopupArea__LearnMoreLink",
    componentId: "sc-c83c01d7-0"
})(_templateObject());
var PopupArea = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "HeaderPopupArea__PopupArea",
    componentId: "sc-c83c01d7-1"
})(_templateObject1(), global_styles__WEBPACK_IMPORTED_MODULE_4__.SB, global_styles__WEBPACK_IMPORTED_MODULE_4__.SB);


/***/ })

}]);